export enum QuestionType {
  content_types = "Content types",
  courses = "Courses",
  curriculum_complements = "Curriculum complements",
  ela_standards_and_skills = "Reading skills",
  topics_and_themes = "Topics and themes",
  topics = "Topics",
  novel_studies = "Novel studies",
  custom_resources = "Custom resources",
  supplemental_collections = "Supplemental collections",
  additional_curriculum_complements = "Additional curriculum complements",
  additional_novel_studies = "Additional novel studies",
  additional_courses = "Additional courses",
  additional_supplemental_collections = "Additional supplemental collections",
}
